// services/companyApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;

// console.log("token REACT_APP_QWIK_MEDIC_API_URL", API_URL, TOKEN);

// const API_URL = "https://qwikmedic1.qwikbistro.ca/";
// const TOKEN = "d0ce846f0cc0c34a14348caded1f3acfbb62cb76";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const companyApiService = {
  // Get company discount data
  getCompanyDiscount: async () => {
    try {
      const response = await axiosInstance.get('companyContacts/1');

      console.log("response.data", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching company discount:', error);
      throw error;
    }
  },

  // Update medicine discount
  updateMedicineDiscount: async (discountValue) => {
    try {
      const response = await axiosInstance.patch('companyContacts/1', {
        medicinediscount: discountValue
      });
      return response.data;
    } catch (error) {
      console.error('Error updating medicine discount:', error);
      throw error;
    }
  },

  // Update product discount
  updateProductDiscount: async (discountValue) => {
    try {
      const response = await axiosInstance.patch('companyContacts/1', {
        productdiscount: discountValue
      });
      return response.data;
    } catch (error) {
      console.error('Error updating medicine discount:', error);
      throw error;
    }
  },
};